export const GLOBAL_SCOPE_ID = "GLOBAL";
export const EMEA_SCOPE_ID = "EMEA";
export const APAC_SCOPE_ID = "APAC";
export const LATAM_SCOPE_ID = "LATAM";
export const CARIBBEAN_SCOPE_ID = "CARIBBEAN";
export const UK_SCOPE_ID = "UK";
export const PUBLICATION_REGIONS = [
    {
        slug: "emea",
        name: "Europe, Middle East & Africa",
        publicationIds: [5255740, 5773198, 6252202, 5773212, 6252148, 5653414, 6205076],
        entitlementScopeId: "EMEA",
        memberCountryIds: [
            "107040",
            "107042",
            "107044",
            "107047",
            "107050",
            "107051",
            "107053",
            "107056",
            "107057",
            "107237",
            "107067",
            "107069",
            "107071",
            "107080",
            "107083",
            "107084",
            "107086",
            "107089",
            "107093",
            "107094",
            "107097",
            "107098",
            "107101",
            "107102",
            "107103",
            "107104",
            "107105",
            "107106",
            "107115",
            "107116",
            "107119",
            "107120",
            "107121",
            "107123",
            "107124",
            "107125",
            "107129",
            "107130",
            "107131",
            "107132",
            "107133",
            "107134",
            "107136",
            "107137",
            "107139",
            "107140",
            "107141",
            "107142",
            "107149",
            "107151",
            "107153",
            "107154",
            "107156",
            "107157",
            "107158",
            "107162",
            "107167",
            "107144",
            "107169",
            "107170",
            "107177",
            "107178",
            "107180",
            "107181",
            "107182",
            "107186",
            "107188",
            "107189",
            "107192",
            "107193",
            "107194",
            "107196",
            "107204",
            "107205",
            "107208",
            "107209",
            "107213",
            "107214",
            "107217",
            "107219",
            "107220",
            "107223",
            "107228",
            "1037119",
            "860027",
        ],
        memberCountryNames: {
            "107040": "Albania",
            "107042": "Algeria",
            "107044": "Angola",
            "107047": "Armenia",
            "107050": "Austria",
            "107051": "Azerbaijan",
            "107053": "Bahrain",
            "107056": "Belarus",
            "107057": "Belgium",
            "107237": "Bosnia & Herzegovina",
            "107067": "Bulgaria",
            "107069": "Burundi",
            "107071": "Cameroon",
            "107080": "Croatia",
            "107083": "Cyprus",
            "107084": "Czech Republic",
            "107086": "Denmark",
            "107089": "Egypt",
            "107093": "Estonia",
            "107094": "Ethiopia",
            "107097": "Finland",
            "107098": "France",
            "107101": "Georgia",
            "107102": "Germany",
            "107103": "Ghana",
            "107104": "Gibraltar",
            "107105": "Greece",
            "107106": "Greenland",
            "107115": "Hungary",
            "107116": "Iceland",
            "107119": "Iran",
            "107120": "Iraq",
            "107121": "Ireland",
            "107123": "Israel",
            "107124": "Italy",
            "107125": "Ivory Coast",
            "107129": "Jordan",
            "107130": "Kazakhstan",
            "107131": "Kenya",
            "107132": "Kosovo",
            "107133": "Kuwait",
            "107134": "Kyrgyzstan",
            "107136": "Latvia",
            "107137": "Lebanon",
            "107139": "Libya",
            "107140": "Liechtenstein",
            "107141": "Lithuania",
            "107142": "Luxembourg",
            "107149": "Malta",
            "107151": "Mauritius",
            "107153": "Moldova",
            "107154": "Monaco",
            "107156": "Montenegro",
            "107157": "Morocco",
            "107158": "Mozambique",
            "107162": "Netherlands",
            "107167": "Nigeria",
            "107144": "North Macedonia",
            "107169": "Norway",
            "107170": "Oman",
            "107177": "Poland",
            "107178": "Portugal",
            "107180": "Qatar",
            "107181": "Romania",
            "107182": "Russia",
            "107186": "Saudi Arabia",
            "107188": "Senegal",
            "107189": "Serbia",
            "107192": "Slovakia",
            "107193": "Slovenia",
            "107194": "South Africa",
            "107196": "Spain",
            "107204": "Sweden",
            "107205": "Switzerland",
            "107208": "Tajikistan",
            "107209": "Tanzania",
            "107213": "Tunisia",
            "107214": "Turkey",
            "107217": "Uganda",
            "107219": "Ukraine",
            "107220": "United Arab Emirates",
            "107223": "Uzbekistan",
            "107228": "Zambia",
            "1037119": "Paris",
            "860027": "Deutschland",
        },
        guideParentIds: [111132],
    },
    {
        slug: "asia-pacific",
        name: "Asia Pacific",
        publicationIds: [5781468, 5781544, 6006838, 6245600, 6238768, 6313732, 6360660],
        entitlementScopeId: "APAC",
        memberCountryIds: [
            "107049",
            "107054",
            "107066",
            "107070",
            "107077",
            "107114",
            "107117",
            "107118",
            "107127",
            "107135",
            "107143",
            "107147",
            "107155",
            "107159",
            "107161",
            "107164",
            "107171",
            "107173",
            "107176",
            "107191",
            "107195",
            "107197",
            "107207",
            "107210",
            "107225",
            "874585",
        ],
        memberCountryNames: {
            "107049": "Australia",
            "107054": "Bangladesh",
            "107066": "Brunei",
            "107070": "Cambodia",
            "107077": "China",
            "107114": "Hong Kong",
            "107117": "India",
            "107118": "Indonesia",
            "107127": "Japan",
            "107135": "Laos",
            "107143": "Macau",
            "107147": "Malaysia",
            "107155": "Mongolia",
            "107159": "Myanmar",
            "107161": "Nepal",
            "107164": "New Zealand",
            "107171": "Pakistan",
            "107173": "Papua New Guinea",
            "107176": "Philippines",
            "107191": "Singapore",
            "107195": "South Korea",
            "107197": "Sri Lanka",
            "107207": "Taiwan",
            "107210": "Thailand",
            "107225": "Vietnam",
            "874585": "Asia Pacific: Regional International Arbitration",
        },
        guideParentIds: [111127],
    },
    {
        slug: "uk",
        name: "United Kingdom",
        publicationIds: [5569426, 6042066],
        entitlementScopeId: "UK",
        memberCountryIds: [
            "107037",
            "107091",
            "107110",
            "107122",
            "107128",
            "107168",
            "107187",
            "107226",
            "107239",
            "107240",
            "107241",
            "107242",
            "107243",
            "107245",
            "107246",
            "114397",
            "117859",
            "200852",
        ],
        memberCountryNames: {
            "107037": "England",
            "107091": "England",
            "107110": "Guernsey",
            "107122": "Isle of Man",
            "107128": "Jersey",
            "107168": "Northern Ireland",
            "107187": "Scotland",
            "107226": "Wales",
            "107239": "East Midlands",
            "107240": "London",
            "107241": "North West",
            "107242": "South East",
            "107243": "South West",
            "107245": "West Midlands",
            "107246": "Yorkshire",
            "114397": "North",
            "117859": "East Anglia",
            "200852": "United Kingdom",
        },
        guideParentIds: [9],
    },
    {
        slug: "united-states",
        name: "United States",
        publicationIds: [5264656, 5857666, 6110136, 6222682, 6284878, 6374798],
        entitlementScopeId: null,
        memberCountryIds: ["107233"],
        memberCountryNames: {
            "107233": "United States",
        },
        guideParentIds: [111131],
    },
    {
        slug: "canada",
        name: "Canada",
        publicationIds: [5791698, 6040092],
        entitlementScopeId: null,
        memberCountryIds: ["107072"],
        memberCountryNames: {
            "107072": "Canada",
        },
        guideParentIds: [111128],
    },
    {
        slug: "latin-america",
        name: "Latin America",
        publicationIds: [5570240, 6040104],
        entitlementScopeId: "LATAM",
        memberCountryIds: [
            "107046",
            "107061",
            "107064",
            "1965619",
            "107076",
            "107078",
            "107079",
            "107087",
            "107088",
            "107090",
            "107109",
            "107113",
            "119989",
            "107152",
            "107165",
            "107172",
            "107174",
            "107175",
            "107179",
            "107221",
            "107224",
        ],
        memberCountryNames: {
            "107046": "Argentina",
            "107061": "Bolivia",
            "107064": "Brazil",
            "1965619": "Central America",
            "107076": "Chile",
            "107078": "Colombia",
            "107079": "Costa Rica",
            "107087": "Dominican Republic",
            "107088": "Ecuador",
            "107090": "El Salvador",
            "107109": "Guatemala",
            "107113": "Honduras",
            "119989": "Latin America International firms",
            "107152": "Mexico",
            "107165": "Nicaragua",
            "107172": "Panama",
            "107174": "Paraguay",
            "107175": "Peru",
            "107179": "Puerto Rico",
            "107221": "Uruguay",
            "107224": "Venezuela",
        },
        guideParentIds: [111130],
    },
    {
        slug: "caribbean",
        name: "Caribbean",
        publicationIds: [5792016, 6042064],
        entitlementScopeId: "CARIBBEAN",
        memberCountryIds: [
            "107052",
            "107055",
            "107060",
            "107065",
            "107074",
            "107126",
            "107199",
            "107200",
            "107216",
            "5815032",
            "1888773",
            "3051136",
            "4133102",
            "4133104",
            "5814474",
        ],
        memberCountryNames: {
            "107052": "Bahamas",
            "107055": "Barbados",
            "107060": "Bermuda",
            "107065": "British Virgin Islands",
            "107074": "Cayman Islands",
            "107126": "Jamaica",
            "107199": "St Lucia",
            "107200": "St Vincent & the Grenadines",
            "107216": "Turks And Caicos Islands",
            "5815032": "Saint Kitts and Nevis",
            "1888773": "Dutch Caribbean",
            "3051136": "The English Bar Offshore",
            "4133102": "Foreign-based expertise",
            "4133104": "Cross-Caribbean expertise",
            "5814474": "Elsewhere in the Caribbean",
        },
        guideParentIds: [111129],
    },
    {
        slug: "uk-solicitors-guide",
        name: "UK Solicitors Guide",
        publicationIds: [],
        entitlementScopeId: null,
        memberCountryIds: [
            "107037",
            "107091",
            "107110",
            "107122",
            "107128",
            "107168",
            "107187",
            "107226",
            "107239",
            "107240",
            "107241",
            "107242",
            "107243",
            "107245",
            "107246",
            "114397",
            "117859",
            "200852",
            "856623",
        ],
        memberCountryNames: {
            "107037": "England",
            "107091": "England",
            "107110": "Guernsey",
            "107122": "Isle of Man",
            "107128": "Jersey",
            "107168": "Northern Ireland",
            "107187": "Scotland",
            "107226": "Wales",
            "107239": "East Midlands",
            "107240": "London",
            "107241": "North West",
            "107242": "South East",
            "107243": "South West",
            "107245": "West Midlands",
            "107246": "Yorkshire",
            "114397": "North",
            "117859": "East Anglia",
            "200852": "United Kingdom",
            "856623": "Unmapped (site structure 856623)",
        },
        guideParentIds: [9],
    },
    {
        slug: "asia-pacific-guide",
        name: "Asia Pacific Guide",
        publicationIds: [],
        entitlementScopeId: null,
        memberCountryIds: [
            "107039",
            "107047",
            "107049",
            "107051",
            "107054",
            "107066",
            "107070",
            "107077",
            "107101",
            "107114",
            "107117",
            "107118",
            "107127",
            "107130",
            "107134",
            "107135",
            "107143",
            "107147",
            "107155",
            "107159",
            "107161",
            "107164",
            "107171",
            "107173",
            "107176",
            "107191",
            "107195",
            "107197",
            "107207",
            "107208",
            "107210",
            "107211",
            "107215",
            "107223",
            "107225",
            "1379295",
            "1419743",
            "4174314",
        ],
        memberCountryNames: {
            "107039": "Afghanistan",
            "107047": "Armenia",
            "107049": "Australia",
            "107051": "Azerbaijan",
            "107054": "Bangladesh",
            "107066": "Brunei",
            "107070": "Cambodia",
            "107077": "China",
            "107101": "Georgia",
            "107114": "Hong Kong",
            "107117": "India",
            "107118": "Indonesia",
            "107127": "Japan",
            "107130": "Kazakhstan",
            "107134": "Kyrgyzstan",
            "107135": "Laos",
            "107143": "Macau",
            "107147": "Malaysia",
            "107155": "Mongolia",
            "107159": "Myanmar",
            "107161": "Nepal",
            "107164": "New Zealand",
            "107171": "Pakistan",
            "107173": "Papua New Guinea",
            "107176": "Philippines",
            "107191": "Singapore",
            "107195": "South Korea",
            "107197": "Sri Lanka",
            "107207": "Taiwan",
            "107208": "Tajikistan",
            "107210": "Thailand",
            "107211": "Timor-Leste",
            "107215": "Turkmenistan",
            "107223": "Uzbekistan",
            "107225": "Vietnam",
            "1379295": "Australia Bar",
            "1419743": "Hong Kong Bar",
            "4174314": "Maldives",
        },
        guideParentIds: [111127],
    },
    {
        slug: "caribbean-guide",
        name: "Caribbean Guide",
        publicationIds: [],
        entitlementScopeId: null,
        memberCountryIds: [
            "107048",
            "107052",
            "107055",
            "107060",
            "107065",
            "107074",
            "107082",
            "107107",
            "107126",
            "107184",
            "107199",
            "107200",
            "107216",
            "1888773",
            "3051136",
            "4133102",
            "4133104",
            "4171382",
            "5814474",
            "5815032",
        ],
        memberCountryNames: {
            "107048": "Aruba",
            "107052": "Bahamas",
            "107055": "Barbados",
            "107060": "Bermuda",
            "107065": "British Virgin Islands",
            "107074": "Cayman Islands",
            "107082": "Curacao",
            "107107": "Grenada",
            "107126": "Jamaica",
            "107184": "Sint Maarten",
            "107199": "St Lucia",
            "107200": "St Vincent & the Grenadines",
            "107216": "Turks And Caicos Islands",
            "1888773": "Dutch Caribbean",
            "3051136": "The English Bar Offshore",
            "4133102": "Foreign-based expertise",
            "4133104": "Cross-Caribbean expertise",
            "4171382": "Bonaire",
            "5814474": "Elsewhere in the Caribbean",
            "5815032": "Saint Kitts and Nevis",
        },
        guideParentIds: [111129],
    },
    {
        slug: "latin-america-guide",
        name: "Latin America Guide",
        publicationIds: [],
        entitlementScopeId: null,
        memberCountryIds: [
            "107045",
            "107046",
            "107061",
            "107064",
            "107076",
            "107078",
            "107079",
            "107087",
            "107088",
            "107090",
            "107109",
            "107113",
            "107152",
            "107165",
            "107172",
            "107174",
            "107175",
            "107179",
            "107221",
            "107224",
            "119989",
            "1965619",
        ],
        memberCountryNames: {
            "107045": "Anguilla",
            "107046": "Argentina",
            "107061": "Bolivia",
            "107064": "Brazil",
            "107076": "Chile",
            "107078": "Colombia",
            "107079": "Costa Rica",
            "107087": "Dominican Republic",
            "107088": "Ecuador",
            "107090": "El Salvador",
            "107109": "Guatemala",
            "107113": "Honduras",
            "107152": "Mexico",
            "107165": "Nicaragua",
            "107172": "Panama",
            "107174": "Paraguay",
            "107175": "Peru",
            "107179": "Puerto Rico",
            "107221": "Uruguay",
            "107224": "Venezuela",
            "119989": "Latin America: International firms",
            "1965619": "Central America",
        },
        guideParentIds: [111130],
    },
    {
        slug: "emea-guide",
        name: "Europe, Middle East & Africa Guide",
        publicationIds: [],
        entitlementScopeId: null,
        memberCountryIds: [
            "107040",
            "107042",
            "107044",
            "107050",
            "107053",
            "107056",
            "107057",
            "107059",
            "107063",
            "107067",
            "107068",
            "107069",
            "107071",
            "107073",
            "107075",
            "107080",
            "107083",
            "107084",
            "107085",
            "107086",
            "107089",
            "107092",
            "107093",
            "107094",
            "107097",
            "107098",
            "107099",
            "107100",
            "107102",
            "107103",
            "107104",
            "107105",
            "107106",
            "107111",
            "107115",
            "107116",
            "107119",
            "107120",
            "107121",
            "107123",
            "107124",
            "107125",
            "107129",
            "107131",
            "107132",
            "107133",
            "107136",
            "107137",
            "107138",
            "107139",
            "107140",
            "107141",
            "107142",
            "107144",
            "107145",
            "107146",
            "107148",
            "107149",
            "107150",
            "107151",
            "107153",
            "107154",
            "107156",
            "107157",
            "107158",
            "107160",
            "107162",
            "107166",
            "107167",
            "107169",
            "107170",
            "107177",
            "107178",
            "107180",
            "107181",
            "107182",
            "107183",
            "107186",
            "107188",
            "107189",
            "107190",
            "107192",
            "107193",
            "107194",
            "107196",
            "107201",
            "107203",
            "107204",
            "107205",
            "107206",
            "107209",
            "107213",
            "107214",
            "107217",
            "107219",
            "107220",
            "107227",
            "107228",
            "107229",
            "107231",
            "107237",
            "4368878",
        ],
        memberCountryNames: {
            "107040": "Albania",
            "107042": "Algeria",
            "107044": "Angola",
            "107050": "Austria",
            "107053": "Bahrain",
            "107056": "Belarus",
            "107057": "Belgium",
            "107059": "Benin",
            "107063": "Botswana",
            "107067": "Bulgaria",
            "107068": "Burkina Faso",
            "107069": "Burundi",
            "107071": "Cameroon",
            "107073": "Cape Verde",
            "107075": "Chad",
            "107080": "Croatia",
            "107083": "Cyprus",
            "107084": "Czech Republic",
            "107085": "Democratic Republic Of The Congo",
            "107086": "Denmark",
            "107089": "Egypt",
            "107092": "Equatorial Guinea",
            "107093": "Estonia",
            "107094": "Ethiopia",
            "107097": "Finland",
            "107098": "France",
            "107099": "Gabon",
            "107100": "Gambia",
            "107102": "Germany",
            "107103": "Ghana",
            "107104": "Gibraltar",
            "107105": "Greece",
            "107106": "Greenland",
            "107111": "Guinea",
            "107115": "Hungary",
            "107116": "Iceland",
            "107119": "Iran",
            "107120": "Iraq",
            "107121": "Ireland",
            "107123": "Israel",
            "107124": "Italy",
            "107125": "Ivory Coast",
            "107129": "Jordan",
            "107131": "Kenya",
            "107132": "Kosovo",
            "107133": "Kuwait",
            "107136": "Latvia",
            "107137": "Lebanon",
            "107138": "Lesotho",
            "107139": "Libya",
            "107140": "Liechtenstein",
            "107141": "Lithuania",
            "107142": "Luxembourg",
            "107144": "North Macedonia",
            "107145": "Madagascar",
            "107146": "Malawi",
            "107148": "Mali",
            "107149": "Malta",
            "107150": "Mauritania",
            "107151": "Mauritius",
            "107153": "Moldova",
            "107154": "Monaco",
            "107156": "Montenegro",
            "107157": "Morocco",
            "107158": "Mozambique",
            "107160": "Namibia",
            "107162": "Netherlands",
            "107166": "Niger",
            "107167": "Nigeria",
            "107169": "Norway",
            "107170": "Oman",
            "107177": "Poland",
            "107178": "Portugal",
            "107180": "Qatar",
            "107181": "Romania",
            "107182": "Russia",
            "107183": "Rwanda",
            "107186": "Saudi Arabia",
            "107188": "Senegal",
            "107189": "Serbia",
            "107190": "Seychelles",
            "107192": "Slovakia",
            "107193": "Slovenia",
            "107194": "South Africa",
            "107196": "Spain",
            "107201": "Sudan",
            "107203": "Swaziland",
            "107204": "Sweden",
            "107205": "Switzerland",
            "107206": "Syria",
            "107209": "Tanzania",
            "107213": "Tunisia",
            "107214": "Turkey",
            "107217": "Uganda",
            "107219": "Ukraine",
            "107220": "United Arab Emirates",
            "107227": "Yemen",
            "107228": "Zambia",
            "107229": "Zimbabwe",
            "107231": "Congo",
            "107237": "Bosnia & Herzegovina",
            "4368878": "Palestine",
        },
        guideParentIds: [111132],
    },
    {
        slug: "uk-bar-guide",
        name: "UK Bar Guide",
        publicationIds: [],
        entitlementScopeId: null,
        memberCountryIds: ["107247", "107248", "107249", "107251", "1096249"],
        memberCountryNames: {
            "107247": "Regional Bar",
            "107248": "London Bar",
            "107249": "Scottish Bar",
            "107251": "Regional International Arbitration \u2013 The Bar",
            "1096249": "Middle East: The English Bar",
        },
        guideParentIds: [111133],
    },
    {
        slug: "deutschland-guide",
        name: "Deutschland Guide",
        publicationIds: [],
        entitlementScopeId: null,
        memberCountryIds: ["860027"],
        memberCountryNames: {
            "860027": "Deutschland",
        },
        guideParentIds: [111134],
    },
    {
        slug: "paris-guide",
        name: "Paris Guide",
        publicationIds: [],
        entitlementScopeId: null,
        memberCountryIds: ["107098", "1037119"],
        memberCountryNames: {
            "107098": "France",
            "1037119": "Paris",
        },
        guideParentIds: [111135],
    },
    {
        slug: "global-editorial",
        name: "Global (editorial)",
        publicationIds: [],
        entitlementScopeId: null,
        memberCountryIds: ["1151955"],
        memberCountryNames: {
            "1151955": "Global",
        },
        guideParentIds: [
            9, 111127, 111128, 111129, 111130, 111131, 111132, 111133, 111134, 111135, 6110122, 6110166,
        ],
    },
];
export function getCountryIdsForScope(scopeId) {
    return PUBLICATION_REGIONS.filter(region => region.entitlementScopeId === scopeId).flatMap(region => region.memberCountryIds);
}
const WORLDWIDE_SENTINEL_IDS = new Set([GLOBAL_SCOPE_ID, "Worldwide", "5693884"]);
function isWorldwideSentinel(scopeId) {
    return WORLDWIDE_SENTINEL_IDS.has(scopeId);
}
function regionMatchesScopeId(region, scopeId) {
    return (region.entitlementScopeId === scopeId ||
        region.slug === scopeId ||
        region.memberCountryIds.includes(scopeId));
}
/**
 * Resolves a list of scope ids (worldwide sentinel, entitlementScopeId, slug, or member country id)
 * down to the set of PublicationRegions they select, de-duplicated and in first-seen order.
 */
export function getRegionsForScope(scopeIds) {
    const matchedRegions = [];
    const seenSlugs = new Set();
    const addRegion = (region) => {
        if (seenSlugs.has(region.slug))
            return;
        seenSlugs.add(region.slug);
        matchedRegions.push(region);
    };
    for (const scopeId of scopeIds) {
        if (isWorldwideSentinel(scopeId)) {
            for (const region of PUBLICATION_REGIONS) {
                addRegion(region);
            }
            continue;
        }
        for (const region of PUBLICATION_REGIONS) {
            if (regionMatchesScopeId(region, scopeId)) {
                addRegion(region);
            }
        }
    }
    return matchedRegions;
}
/**
 * De-duplicated union of publicationIds across all regions resolved from the given scope ids.
 */
export function getPublicationIdsForScope(scopeIds) {
    const publicationIds = new Set();
    for (const region of getRegionsForScope(scopeIds)) {
        for (const publicationId of region.publicationIds) {
            publicationIds.add(publicationId);
        }
    }
    return Array.from(publicationIds);
}
const GUIDE_REGIONS = PUBLICATION_REGIONS.filter(region => region.entitlementScopeId === null);
function entitlementRegionForScopeString(scopeId) {
    return PUBLICATION_REGIONS.find(region => region.entitlementScopeId === scopeId);
}
/**
 * De-duplicated union of guideParentIds (fulfilment.country_publication_guide
 * publication_parent_id values) across all regions resolved from the given scope ids.
 *
 * Routing is deliberately narrower than getRegionsForScope to avoid cross-contamination
 * between entitlement scope and publication guide:
 *   - a Worldwide sentinel resolves to every guide region's (entitlementScopeId === null)
 *     guideParentIds;
 *   - a scope id equal to an entitlement region's entitlementScopeId (e.g. "EMEA") resolves
 *     to that region's own guideParentIds only;
 *   - any other (numeric country) scope id resolves ONLY from the null-scope guide regions
 *     whose memberCountryIds include it -- never from an entitlement region's
 *     guideParentIds, since entitlement regions can contain member countries whose true
 *     guide differs from the entitlement region's own canonical guide.
 */
export function getGuideParentIdsForScope(scopeIds) {
    const guideParentIds = new Set();
    const addGuideRegionIds = (region) => {
        for (const guideParentId of region.guideParentIds) {
            guideParentIds.add(guideParentId);
        }
    };
    for (const scopeId of scopeIds) {
        if (isWorldwideSentinel(scopeId)) {
            for (const region of GUIDE_REGIONS) {
                addGuideRegionIds(region);
            }
            continue;
        }
        const entitlementRegion = entitlementRegionForScopeString(scopeId);
        if (entitlementRegion) {
            addGuideRegionIds(entitlementRegion);
            continue;
        }
        for (const region of GUIDE_REGIONS) {
            if (region.memberCountryIds.includes(scopeId)) {
                addGuideRegionIds(region);
            }
        }
    }
    return Array.from(guideParentIds);
}
export function findRegionForCountry(countryId) {
    return PUBLICATION_REGIONS.find(region => region.memberCountryIds.includes(countryId));
}
export function getCountryName(countryId) {
    for (const region of PUBLICATION_REGIONS) {
        const name = region.memberCountryNames[countryId];
        if (name !== undefined) {
            return name;
        }
    }
    return undefined;
}
const ALL_SCOPE_IDS = new Set([
    GLOBAL_SCOPE_ID,
    ...PUBLICATION_REGIONS.filter(r => r.entitlementScopeId !== null).map(r => r.entitlementScopeId),
]);
export function isBroadScope(siteStructureId) {
    return ALL_SCOPE_IDS.has(siteStructureId);
}
const countryToRegionIds = new Map();
for (const region of PUBLICATION_REGIONS) {
    if (region.entitlementScopeId === null)
        continue;
    for (const countryId of region.memberCountryIds) {
        const existing = countryToRegionIds.get(countryId) ?? [];
        countryToRegionIds.set(countryId, [...existing, region.entitlementScopeId]);
    }
}
/**
 * Expands a set of siteStructureIds to include their parent region IDs and the Worldwide ID.
 */
export function expandRegionHierarchy(ids) {
    const nonEmpty = ids.filter(id => id !== "");
    if (nonEmpty.length === 0)
        return [];
    const expanded = new Set(nonEmpty);
    for (const id of nonEmpty) {
        const parentRegions = countryToRegionIds.get(id);
        if (parentRegions) {
            for (const regionId of parentRegions) {
                expanded.add(regionId);
            }
        }
    }
    expanded.add(GLOBAL_SCOPE_ID);
    return Array.from(expanded);
}
//# sourceMappingURL=publication-regions.js.map